export interface EventPosterConfig {
  id: string;
  src: string;
  titleKey: string;
  altKey?: string;
  path?: string;
}

export const eventPosters: EventPosterConfig[] = [
  {
    id: 'the-relic',
    src: 'https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt/story_bubi/poster/the_relic.png',
    titleKey: 'eventPosterModal.theRelic.title',
    altKey: 'eventPosterModal.theRelic.title',
    path: '/story/0'
  },
  {
    id: 'bubble-throne',
    src: 'https://hmseykssvtyrihuxymeo.supabase.co/storage/v1/object/public/bbt/landing/bubble_throne.jpg',
    titleKey: 'eventPosterModal.bubbleThrone.title',
    altKey: 'eventPosterModal.bubbleThrone.title',
    path: '/throne-battle'
  }
];

export const EVENT_POSTER_DISMISS_KEY = 'event_modal_dismissed_signature';

export const EVENT_POSTER_SIGNATURE = JSON.stringify(
  eventPosters.map((poster) => ({
    id: poster.id,
    src: poster.src,
    path: poster.path ?? ''
  }))
);
